import { useEffect, useState } from "react";
import { useMainContext } from "../../../Context";
import Input from "../../../Components/Form/Input";
import Button from "../../../Components/Btn";
import { PasswordCheck, Sms } from "../../../Utils/icons";
import { email, password } from "../../../Utils/Apis";
import { toast } from "react-toastify";
export const useProfile = () => {
  const {
    state: { user },
    post,
    dispatch,
  } = useMainContext();
  const [form, setForm] = useState({ show: false });
  const isPerson = () => {
    if (user?.user?.accountable?.account_type === "personal") {
      return true;
    } else {
      return false;
    }
  };
  const hasPassword = () => {
    return user?.user?.has_password;
  };
  const updateEmail = async () => {
    setForm({ ...form, loading: true });
    const { data, status } = await post(email, form, true);
    if (+status === 200) {
      dispatch("user", { ...user, user: { ...user.user, email: form.email } });
    }
    setForm({ ...form, loading: false, show: false });
  };
  const updatePassword = async () => {
    setForm({ ...form, loading: true });
    const { data, status } = await post(password, form, true);
    setForm({ ...form, loading: false, show: false });
  };
  useEffect(() => {
    setForm({ ...form, email: user?.user?.email });
  }, [form.show]);
  const render = () => {
    switch (form.show) {
      case "email":
        return (
          <>
            <Input
              label="ایمیل"
              props={{
                value: form.email,
                onChange: ({ target: { value } }) => {
                  setForm({ ...form, email: value });
                },
                onKeyDown: ({ key }) => {
                  if (key === "Enter") {
                    updateEmail();
                  }
                },
                value: form.email,
              }}
              leftIcon={() => <Sms />}
            />
            <Button
              className="mt-11"
              text={"تغییر ایمیل"}
              onClick={updateEmail}
              loading={form.loading}
            />
          </>
        );
      case "password":
        return (
          <>
            {hasPassword() && (
              <Input
                label="گذرواژه قبلی"
                props={{
                  onChange: ({ target: { value } }) => {
                    setForm({ ...form, current_password: value });
                  },
                  onKeyDown: ({ key }) => {
                    if (key === "Enter") {
                      updateEmail();
                    }
                  },
                  type: "password",
                  value: form.current_password,
                }}
                leftIcon={() => <PasswordCheck />}
              />
            )}
            <Input
              label="گذرواژه جدید"
              className="mt-11"
              props={{
                onChange: ({ target: { value } }) => {
                  setForm({ ...form, password: value });
                },
                onKeyDown: ({ key }) => {
                  if (key === "Enter") {
                    updateEmail();
                  }
                },
                type: "password",
                value: form.password,
              }}
              leftIcon={() => <PasswordCheck />}
            />{" "}
            <Input
              label="تکرار گذرواژه جدید"
              className="mt-11"
              props={{
                onChange: ({ target: { value } }) => {
                  setForm({ ...form, password_confirmation: value });
                },
                onKeyDown: ({ key }) => {
                  if (key === "Enter") {
                    updatePassword();
                  }
                },
                type: "password",
                value: form.password_confirmation,
              }}
              leftIcon={() => <PasswordCheck />}
            />
            <Button
              className="mt-11"
              text={"تغییر گذرواژه"}
              onClick={updatePassword}
              loading={form.loading}
            />
          </>
        );
        break;

      default:
        break;
    }
  };
  return { user, isPerson, form, setForm, render, updateEmail, updatePassword };
};
